import { render } from "./door-sales-preferences.vue?vue&type=template&id=c1703cda&scoped=true"
import script from "./door-sales-preferences.vue?vue&type=script&lang=js"
export * from "./door-sales-preferences.vue?vue&type=script&lang=js"

import "./door-sales-preferences.vue?vue&type=style&index=0&id=c1703cda&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.2.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@5.94.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1703cda"]])

export default __exports__